<template >
	<div class="container">
	<div class="row p-5">
	<div class="col-sm-6">
		<h2>About Us</h2>
		<hr >
		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>
	</div>
		<div class="col-sm-6">

			<h2 class="text-center register-class">REGISTER</h2>
			<div class="card register-card">
				<div class="card-body">
					<form action = "" >
					<div class="form-group">
						<label >Name</label >
						<input type = "text" class="form-control">
					</div>
					<div class="form-group">
						<label >Email</label >
						<input type = "email" class="form-control">
					</div>
					<div class="form-group">
						<label >Password</label >
						<input type = "password" class="form-control">
					</div>
					<div class="form-group">
						<label >Canfirm Password</label >
						<input type = "password" class="form-control">
					</div>
						<div class="reg-btn">
						<button type="submit" class="btn btn-dark register-button">Register</button>
						</div>
					</form >
				</div>
			</div>
		</div>
	</div>
	</div>
</template >
<script >
	export default {
		name: "customRegister"
	}
</script >
<style scoped >
	.register-class{
		background-color: #F99800;
		color: #ffffff;
		padding: 2px;
		margin-bottom: 5%;
		}
	.register-card .card-body{
		background-color: #132E41;
		padding: 7%;
		color: white;
		}
	.register-button{
		background-color: #FC9301;
		color: white;
		border-radius: 18px;
		text-align: center;
		padding-left: 7%;
		padding-right: 7%;
		align-content: center;
		}
	.reg-btn{
		text-align: center;
		}
</style >